import React, { Component } from "react"

import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from "reactstrap"
import UncontrolledTooltip from "@common/display/ToolTip/UncontrolledTooltip"
import { Alert } from "reactstrap"

import { Loading } from "@common/EcosuiteComponent"

import SiteSystems from "./SiteSystems"
import Icon from "@common/display/Icon"
import i18n from "src/i18n"
import EnergyService from "@dashboard/energy/EnergyService"

const { t } = i18n
class ProjectSites extends Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.systemChanged = this.systemChanged.bind(this)
    this.state = { activeTab: null }
  }

  componentDidMount() {
    if (this.props.project) {
      this.selectDefaultSite()
      if (this.props.SNDevices) this.loadDevices()
    }
  }

  async loadDevices() {
    EnergyService.getProjectNodesDeviceInfo(this.props.project.code, this.props.project.startDate)
      .then((result) => {
        const sortedDevices = this.sortDevicesBySiteSystem(result.datums)
        this.setState({ projectSNDevices: sortedDevices })
      })
      .catch((error) => {
        this.setState({
          hasError: true,
          error: error,
        })
      })
  }

  sortDevicesBySiteSystem(devices) {
    let sortedDevices = []
    devices.forEach((device) => {
      const parts = device.sourceId.split("/")
      const site = parts[2]
      const system = parts[3]
      if (!sortedDevices[site]) {
        sortedDevices[site] = {}
      }
      if (!sortedDevices[site][system]) {
        sortedDevices[site][system] = []
      }
      sortedDevices[site][system].push(device)
    })
    return sortedDevices
  }

  componentDidUpdate(prevProps) {
    if (this.props.project.code !== prevProps.project.code) {
      this.selectDefaultSite()
      this.loadDevices()
    }
  }

  selectDefaultSite() {
    if (Object.keys(this.props.project.sites).length > 0) {
      this.setState({
        activeTab: Object.keys(this.props.project.sites)[0],
      })
    } else {
      this.setState({
        activeTab: "new-site",
      })
    }
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }

  systemChanged() {
    this.props.projectChanged(this.props.project) // Just notify that the project needs to be updated
  }

  render() {
    if (this.props.project && this.state.activeTab) {
      return (
        <div>
          <Nav tabs>
            {this.props.project.sites && Object.values(this.props.project.sites).length > 0
              ? Object.values(this.props.project.sites).map((site, idx) => {
                  return (
                    <NavItem key={"tab-site-" + idx}>
                      <NavLink
                        className={this.state.activeTab === site.code ? "active" : null}
                        onClick={() => {
                          this.toggle(site.code)
                        }}
                        id={site.code}
                      >
                        {site.name}
                        {site.verified && <Icon icon="verified" className="verified" />}
                      </NavLink>
                      <UncontrolledTooltip target={site.code}>{this.props.verifiedTooltip}</UncontrolledTooltip>
                    </NavItem>
                  )
                })
              : null}
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            {this.props.project.sites && Object.values(this.props.project.sites).length > 0 ? (
              Object.values(this.props.project.sites).map((site) => {
                return (
                  <TabPane tabId={site.code} key={"tab-content-" + site.code}>
                    <Row>
                      <Col sm="12">
                        <SiteSystems
                          project={this.props.project}
                          site={site}
                          siteSNDevices={this.state.projectSNDevices ? this.state.projectSNDevices[site.code] : null}
                          //siteSNDevices={this.state.projectSNDevices[site.code]}
                          SNDevices={this.props.SNDevices}
                          predictedGeneration={
                            this.props.predictedGeneration ? this.props.predictedGeneration.sites[site.code] : null
                          }
                          systemAdded={this.systemChanged}
                          systemChanged={this.systemChanged}
                          systemDeleted={this.systemChanged}
                          autoCompletes={this.props.autoCompletes}
                          readonly={this.props.readonly}
                          verifiedTooltip={this.props.verifiedTooltip}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                )
              })
            ) : (
              <div className="project-sites">
                <Alert color="warning">{t("alertsInfo.project_has_no_site")}</Alert>
              </div>
            )}
          </TabContent>
        </div>
      )
    }

    return <Loading />
  }
}

export default ProjectSites
